module.exports = __webpack_public_path__ + "static/main-b2175315ee3feaebece21eec4c946bad.jpg";